// extracted by mini-css-extract-plugin
export default {"pluginpreview":"eced7e9afeb561cd033c","description":"f3e8b46872fc48735840","section":"bdc0be3b5513fd8f5b47","title":"dc02adeb21a13e995f65"};